import { render, staticRenderFns } from "./ScholarSavedWorks.vue?vue&type=template&id=4e4fa94b&scoped=true&"
import script from "./ScholarSavedWorks.vue?vue&type=script&lang=js&"
export * from "./ScholarSavedWorks.vue?vue&type=script&lang=js&"
import style0 from "./ScholarSavedWorks.vue?vue&type=style&index=0&id=4e4fa94b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4fa94b",
  null
  
)

export default component.exports